import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const updateBookSegmentValidationSchema = Yup.object().shape({
  content: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
